import React from 'react';
import { useDispatch } from 'react-redux';
import CardWithTitle from 'components/CardWithTitle';
import { currencyToLocal } from 'utils/constants';
import { setVendorDetails } from 'actions/vendorDetailsAction';

const OrderProductDetails = ({ currentRow }) => {
  const dispatch = useDispatch();
  const { buyer, seller, grade, rate, rateUnit } = currentRow;

  const handleNameClick = (vendor) => {
    // We assume the vendor object has an id property, like sellerFragment returns.
    // In case the id is not directly available, we can still try to dispatch it.
    // If id is not present but it's part of sellerFragment, it should be fine. 
    // Just dispatching vendor details opens the drawer.
    if (!vendor) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: vendor,
      }),
    );
  };

  const getPhoneNumber = (user) => {
    if (!user?.phone) return '';
    let code = user?.callingCode?.callingCode || '';
    if (code && !code.startsWith('+')) {
      code = `+${code}`;
    }
    return code ? `${code} ${user.phone}` : user.phone;
  };

  return (
    <CardWithTitle title={grade?.name}>
      <h4 className="fw-semibold f-16">
        {`${currencyToLocal(rate, rateUnit?.isoCurrencyCode)}/KG`}
      </h4>
      <div className="mb-2 pb-1">
        <span className="font-manrope text-uppercase text-gray f-12 fw-semibold d-block">
          Buyer
        </span>
        <div 
          className="cursor-pointer" 
          onClick={() => handleNameClick(buyer)}
          aria-hidden
        >
          <p className="font-manrope f-12 fw-medium mb-0 text-blue-c5">
            {buyer?.firstName} {buyer?.lastName}
          </p>
          {buyer?.entityName && (
            <p className="font-manrope f-12 fw-medium mb-0 text-gray">
              {buyer?.entityName}
            </p>
          )}
          {getPhoneNumber(buyer) && (
            <p className="font-manrope f-12 fw-medium mb-0 text-gray">
              {getPhoneNumber(buyer)}
            </p>
          )}
        </div>
      </div>
      <div className="mb-2 pb-1">
        <span className="font-manrope text-uppercase text-gray f-12 fw-semibold d-block">
          Seller
        </span>
        <div 
          className="cursor-pointer" 
          onClick={() => handleNameClick(seller)}
          aria-hidden
        >
          <p className="font-manrope f-12 fw-medium mb-0 text-blue-c5">
            {seller?.firstName} {seller?.lastName}
          </p>
          {seller?.entityName && (
            <p className="font-manrope f-12 fw-medium mb-0 text-gray">
              {seller?.entityName}
            </p>
          )}
          {getPhoneNumber(seller) && (
            <p className="font-manrope f-12 fw-medium mb-0 text-gray">
              {getPhoneNumber(seller)}
            </p>
          )}
        </div>
      </div>
    </CardWithTitle>
  );
};

export default OrderProductDetails;
